import { render } from "./index.vue?vue&type=template&id=ca3d1ebe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ca3d1ebe&lang=scss&scoped=scoped"
import "./index.vue?vue&type=style&index=1&id=ca3d1ebe&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3d1ebe"]])

export default __exports__